import React, {useState} from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Modal } from "../Modal";
import { MUISelect } from "../MUISelect";
import TextField from "@mui/material/TextField";
import {Button} from "../../UI/MUIButton";
import {useModalContext} from "../../contexts/ModalContext/context";
import MenuItem from "@mui/material/MenuItem";
import { Controller, useForm } from "react-hook-form";
import {UploadFileField} from "../UploadFileField/UploadFileField";
import {migrateEntrata, migrateSftpToEntrata} from "../../services/IntegrationApi";
import useAuth from "../../routes/login/AuthContext";
import {useSelectedNetworkContext} from "../../contexts/NetworkContext/context";
import {useSnackbar} from "../../hooks/useSnackbar";

interface IFormData {
    fromType: "ENTRATA" | "SFTP";
    toType: "ENTRATA";
    l1Id: number;
    oldPropertyId: number | undefined;
    newPropertyId: number;
}

interface ImportMigrationModalProps {

}

export const ImportMigrationModal: React.FC<ImportMigrationModalProps> = () => {
    const {getAuthToken} = useAuth();
    const { selectedNetworkId } = useSelectedNetworkContext();
    const { setIsOpen } = useModalContext();
    const { control, handleSubmit } = useForm<IFormData>();
    const [isLoading, setIsLoading] = React.useState(false);
    const [file, setFile] = useState<File | undefined>();
    const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();

    const submitHandler = async (data: IFormData) => {
        if (!file) {
            showErrorSnackbar("must choose a file");
            return;
        }

        if (data.fromType == "ENTRATA" && !data.oldPropertyId) {
            showErrorSnackbar("must enter the old property id");
            return;
        }

        if (data.toType == "ENTRATA" && !data.newPropertyId) {
            showErrorSnackbar("must enter the new property id");
            return;
        }

        if (data.fromType == "ENTRATA" && data.oldPropertyId) {
            setIsLoading(true);
            await migrateEntrata(selectedNetworkId, data.oldPropertyId, data.newPropertyId, data.fromType, data.toType, file, await getAuthToken());
            showSuccessSnackbar("migrated!");
            setIsOpen(false);
        } else if (data.fromType == "SFTP") {
            setIsLoading(true);
            await migrateSftpToEntrata(selectedNetworkId, data.newPropertyId, data.fromType, data.toType, file, await getAuthToken());
            showSuccessSnackbar("migrated!");
            setIsOpen(false);
        }
    };

    const closeModal = () => setIsOpen(false);
    return <Modal
             maxWidth="xs"
             title={"Migrate Import type"}
             actions={
               <>
                 <Button variant="outlined" onClick={closeModal}>
                   Cancel
                 </Button>
                 <Button color="primary" loading={isLoading} variant="contained" onClick={handleSubmit(submitHandler)}>
                     Migrate
                 </Button>
               </>
             }
    >
        <Box p={3} width={350}>
            <Grid container spacing={2}>
                <Grid item>
                  <Controller
                    control={control}
                    name="fromType"
                    render={({field}) => (
                        <ImportTypeSelector label="Original Import Type" fields={field} values={[
                            {value: "ENTRATA", label: "Entrata"},
                            {value: "Email", label: "Email"},
                        ]}/>
                    )}
                  />
                </Grid>
                <Grid item>
                    <Controller
                        control={control}
                        name="toType"
                        defaultValue="ENTRATA"
                        render={({field}) => (
                            <ImportTypeSelector label="New Import Type" fields={field} values={[
                                {value: "ENTRATA", label: "Entrata"}
                            ]}/>
                        )}
                    />
                </Grid>
                <Grid item>
                    <Controller
                         control={control}
                         name={"oldPropertyId"}
                         render={({field}) => (
                             <TextField fullWidth label={"Old Entrata Property Id"} {...field}/>
                         )}
                    />
                </Grid>
                <Grid item>
                    <Controller
                         control={control}
                         name={"newPropertyId"}
                         render={({field}) => (
                             <TextField fullWidth label={"New Entrata Property Id"} {...field}/>
                         )}
                    />
                </Grid>
                <Grid item>
                    <UploadFileField label={"Choose a mapping file"} setFileToUpload={setFile}/>
                </Grid>
            </Grid>
        </Box>
    </Modal>;
};

interface ImportTypeSelectorValues {
    value: string;
    label: string;
}

const ImportTypeSelector: React.FC<{label: string, values: ImportTypeSelectorValues[], fields: any}> = ({label, values, fields}) => {
    return <MUISelect label={label} {...fields}>
        {values.map(entry => <MenuItem value={entry.value}>{entry.label}</MenuItem>)}
    </MUISelect>;
};